export const commonVars = {
  railInsetHorizontalBottom: 'auto 2px 4px 2px',
  railInsetHorizontalTop: '4px 2px auto 2px',
  railInsetVerticalRight: '2px 4px 2px auto',
  railInsetVerticalLeft: '2px auto 2px 4px',
  railColor: 'transparent'
}
